import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLink = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 25,
	height: 24,
	viewBox: "0 0 25 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M17.6667 8.4L6.76667 19.3C6.58334 19.4833 6.35001 19.575 6.06667 19.575C5.78334 19.575 5.55001 19.4833 5.36667 19.3C5.18334 19.1167 5.09167 18.8833 5.09167 18.6C5.09167 18.3167 5.18334 18.0833 5.36667 17.9L16.2667 7H10.6667C10.3833 7 10.1458 6.90417 9.95417 6.7125C9.76251 6.52083 9.66668 6.28333 9.66668 6C9.66668 5.71667 9.76251 5.47917 9.95417 5.2875C10.1458 5.09583 10.3833 5 10.6667 5H18.6667C18.95 5 19.1875 5.09583 19.3792 5.2875C19.5708 5.47917 19.6667 5.71667 19.6667 6V14C19.6667 14.2833 19.5708 14.5208 19.3792 14.7125C19.1875 14.9042 18.95 15 18.6667 15C18.3833 15 18.1458 14.9042 17.9542 14.7125C17.7625 14.5208 17.6667 14.2833 17.6667 14V8.4Z",
		fill: "#178AE9"
	})
});
export default SvgLink;
